module.exports = __webpack_public_path__ + "img/cross-sell-check-icon-white.svg";